import * as React from "react";

interface IMenuItemProps {
  name: string;
  link: string;
}

class MenuItem extends React.Component<IMenuItemProps> {
  render(): JSX.Element {
    return (
      <a href={this.props.link} className="menu-item">
        <span>{this.props.name}</span>
      </a>
    );
  }
}

export default MenuItem;



// WEBPACK FOOTER //
// ./src/components/menuitem.component.tsx